import React from "react";
import { useQuery } from "react-query";
import { useAuth } from "../../../context/AuthContext";
import StatCard from "../../../components/shared/StatCard";
import DataTable from "../../../components/shared/DataTable";
import { formatDate, statusBadgeClass, formatCurrency } from "../../../utils/helpers";
import api from "../../../utils/api";

export default function DoctorDashboard() {
  const { user } = useAuth();

  const { data } = useQuery("doctor-dashboard", () =>
    api.get("/doctor/dashboard")
  );

  const todayColumns = [
    { key: "patientName", label: "Patient" },
    { key: "forName", label: "Booking For" },
    {
      key: "scheduledAt",
      label: "Time",
      render: (row) => formatDate(row.scheduledAt, "hh:mm a"),
    },
    { key: "chamber", label: "Chamber" },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <span className={statusBadgeClass(row.status)}>{row.status}</span>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display font-bold text-2xl text-slate-900">
          Good day, Dr. {user?.name} 👋
        </h2>
        <p className="text-slate-500 text-sm mt-1">
          {new Date().toLocaleDateString("en-IN", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard
          title="Today's Appointments"
          value={data?.todayCount ?? 0}
          icon="📅"
          color="primary"
        />
        <StatCard
          title="Total Appointments"
          value={data?.totalCount ?? 0}
          icon="📋"
          color="success"
        />
        <StatCard
          title="Total Fees Collected"
          value={formatCurrency(data?.totalFees ?? 0)}
          icon="💰"
          color="teal"
        />
      </div>

      {/* Today's Schedule */}
      <div className="card">
        <h3 className="font-display font-semibold text-slate-800 mb-4">
          Today's Schedule
        </h3>
        <DataTable
          columns={todayColumns}
          data={data?.todayAppointments || []}
          emptyMessage="No appointments scheduled for today."
        />
      </div>
    </div>
  );
}
